"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Replace = function Replace(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 56 49'
  }, props), /*#__PURE__*/_react["default"].createElement('g', {
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(-52.000000, -20.000000)',
    fill: 'currentColor',
    fillRule: 'nonzero'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(36.000000, 0.000000)'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(16.000000, 20.000000)'
  }, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M4.44529126,20.9151988 C4.73407772,21.0318847 5.06899205,21.0318847 5.35777851,20.8919054 L14.378376,16.7508157 C14.9558407,16.4708572 15.198391,15.7709608 14.9211906,15.1877503 C14.6555764,14.6278333 13.9972255,14.3711682 13.4312387,14.6278333 L7.11334463,17.532403 C10.1278985,8.42204937 18.5247952,2.33295131 28.1921574,2.33295131 C38.3215563,2.33295131 47.1803815,9.16864191 49.7328986,18.9554891 C49.8945627,19.5736944 50.5298496,19.9470454 51.1419643,19.7836633 C51.754079,19.6203906 52.1237516,18.9787825 51.9619792,18.3605772 C49.1437396,7.55888035 39.3724272,0 28.1920491,0 C17.5314217,0 8.2566878,6.71900476 4.90721965,16.7742185 L2.25075238,10.0669151 C2.05443823,9.46030183 1.39608739,9.12205506 0.79545054,9.32032256 C0.194813685,9.51859007 -0.140100645,10.1834916 0.0562135098,10.7901049 C0.0677996182,10.8368011 0.0908635537,10.8833879 0.113927489,10.9300841 L3.79841825,20.2619987 C3.91395449,20.5536586 4.14491869,20.7986224 4.44529126,20.9151988 Z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M55.929739,38.1377753 C55.9181509,38.1144773 55.906671,38.0910699 55.906671,38.0677719 L52.2215327,28.7340269 C52.1059762,28.4423098 51.8749714,28.197298 51.5746544,28.0806987 C51.2858171,27.9639899 50.950844,27.9756936 50.6620067,28.1039966 L41.6398239,32.2458986 C41.0506696,32.4909104 40.7734206,33.1792403 41.0160135,33.7742689 C41.2586064,34.3692975 41.940141,34.6493109 42.5292952,34.4042992 C42.5523632,34.3925955 42.5755395,34.3810012 42.5986075,34.3692975 L48.9176119,31.464158 C45.8794603,40.5762986 37.4694997,46.6665911 27.8120267,46.6665911 C17.6808476,46.6665911 8.82046555,39.8295597 6.26749982,30.0407928 C6.1058073,29.4224662 5.47040875,29.049042 4.85818649,29.2124561 C4.24596424,29.3757608 3.87622661,30.0174948 4.03802744,30.6358213 C6.84517424,41.4513407 16.629792,49 27.812135,49 C38.4746359,49 47.7394117,42.2796773 51.1010566,32.2224913 L53.7579908,38.9311103 C53.9775157,39.5378425 54.6359822,39.8528577 55.2366164,39.6311439 C55.8372505,39.4095395 56.1491557,38.7445076 55.929739,38.1377753 Z'
  }))))));
};
/* eslint-enable */
var _default = Replace;
exports["default"] = _default;